import { CorrelationGraph } from 'state/quotes/correlations/correlations.model';

export type SelectedCorrelationGraphActions = CorrelationGraphSelected;

export function correlationGraphSelected(tabId: string, value: CorrelationGraph) {
  return {
    type: 'CORRELATION_GRAPH_SELECTED' as const,
    tabId,
    value,
  };
}

type CorrelationGraphSelected = ReturnType<typeof correlationGraphSelected>;
